export default __webpack_public_path__ + "4afab8130f5888832712c36fe2384a80.png";